<template lang="pug">
  .make-an-entry-journal-text
    .make-an-entry-content
      .entry-visibility.mb-2(v-if="isJournal")
        BField(
          label="Image/Note Visible To"
          custom-class="has-text-grey is-small"
        )
          BSelect.visibility-select(
            placeholder="Select"
            v-model="textVisibility"
            size="is-small"
          )
            option.visibility-option(
              v-for="(option,index) in ['Only Me', 'Friends', 'Anyone']"
              :value="index"
              :key="option"
            ) {{ option }}
      section.section.pb-1.pt-2.mt-2
        WtTitle(h4 bold) How did your day go?
        BField
            BInput(
              maxlength="1000"
              type="textarea"
              v-model="journalText"
              placeholder="..."
            )
    .level.is-mobile.program-settings-form-controls
      .level-left
      .level-right
        .level-item
          WtButton(
            is-text
            color="white"
            style="text-decoration:none"
            size="medium"
            @click.native="reset"
            :disabled="disableReset"
          ) Reset
        .level-item
          WtButton(@click.native="saveEntry" :loading="savingJournalText" :disabled="disableSave") SAVE
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import MakeAnEntryFooter from "@@/Members/MakeAnEntry/MakeAnEntryFooter";
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";

export default {
  name: "MakeAnEntryJournalText",

  components: { WtTitle, WtButton, MakeAnEntryFooter },

  mixins: [dateUtilityMixin],

  props: {
    uniqueKey: {
      type: String,
      default: null
    },

    fetchAction: {
      type: Function,
      default: () => {},
      required: true
    },

    // "journal" or "discussion"
    type: {
      type: String,
      default: "journal"
    },

    entryItem: {
      type: Object,
      default: () => {},
      required: true
    },

    challengeId: {
      type: Number,
      default: null
    },

    entryDate: {
      type: String,
      default: ""
    },

    formData: {
      type: FormData,
      required: true,
      validator: value => {
        return value instanceof FormData;
      }
    },

    saveEntryWrapper: {
      type: Function,
      required: true
    },

    disableSave: {
      type: Boolean,
      default: true
    },

    disableReset: {
      type: Boolean,
      default: true
    },

    textVisibilityUpdated: {
      type: Number,
      default: 2
    }
  },

  data() {
    return {
      journalText: "",
      savingJournalText: false,
      textVisibility: 0
    };
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),

    appendJournalText() {
      if (!this._.isEmpty(this.entryItem)) {
        // either it's changed or it might have been changed and changed back to what it was
        return (
          this.journalText !== this.entryItem.text || this.formData.has("text")
        );
      }
      return true;
    },
    appendVisibility() {
      if (!this._.isEmpty(this.entryItem)) {
        // either it's changed or it might have been changed and changed back to what it was
        return (
          this.textVisibility !== this.entryItem.textVisibility ||
          this.formData.has("textVisibility")
        );
      }
      return true;
    },

    isJournal() {
      return this.type === "journal";
    }
  },

  watch: {
    journalText() {
      if (this.appendJournalText) {
        this.formData.set("text", this.journalText);
        this.$emit("formDataUpdated", true);
      }
    },

    textVisibility() {
      if (this.appendVisibility) {
        this.formData.set("textVisibility", this.textVisibility);
        this.formData.set("visibility", this.textVisibility);
        this.$emit("formDataUpdated", true);
        this.$emit("textVisibilityUpdated", this.textVisibility);
      }
    },

    textVisibilityUpdated(newValue) {
      this.textVisibility = newValue;
    }
  },

  mounted() {
    if (!this._.isEmpty(this.entryItem)) {
      this.journalText = this.entryItem.text;
      this.textVisibility = this.entryItem.textVisibility;
    }
  },

  methods: {
    ...mapActions("members", ["updateJournal", "storeJournal"]),
    ...mapActions("challenges", ["updateDiscussion", "storeDiscussion"]),

    async saveEntry() {
      this.savingJournalText = true;

      this.type === "discussion"
        ? await this.saveEntryWrapper(
            this.storeDiscussion,
            this.updateDiscussion
          )
        : await this.saveEntryWrapper(this.storeJournal, this.updateJournal);

      this.savingJournalText = false;
    },

    reset() {
      const item = "text";
      if (this.formData.has(item)) {
        this.formData.delete(item);
      }
      if (this.formData.has("textVisibility")) {
        this.formData.delete("textVisibility");
        this.formData.delete("visibility");
      }
      this.journalText = this.entryItem.text;
      this.textVisibility = this.entryItem.textVisibility;
      this.$nextTick(() => {
        this.$emit("formReset", true);
      });
    }
  }
};
</script>

<style lang="sass">
.make-an-entry-journal-text
  .atwho-view
    max-height: 110px
  .entry-visibility
    position: absolute
    right: 1rem
    top: .5rem
.program-settings-form-controls
  margin-top: 20px
</style>
